import api from "api/axios";

export interface InterviewCategory {
  id: number;
  name: string;
  description: string | null;
  created_at: string | null;
  updated_at: string | null;
  question_count?: number;
}

export interface InterviewQuestion {
  id: number;
  category_id: number | null;
  question: string;
  answer: string | null;
  difficulty: "easy" | "medium" | "hard";
  tags: string[] | null;
  status: "unanswered" | "answered";
  source: string | null;
  notes: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface CategoryCreate {
  name: string;
  description?: string;
}

export interface CategoryUpdate {
  name?: string;
  description?: string;
}

export interface QuestionCreate {
  category_id?: number | null;
  question: string;
  answer?: string;
  difficulty?: "easy" | "medium" | "hard";
  tags?: string[];
  status?: "unanswered" | "answered";
  source?: string;
  notes?: string;
}

export interface QuestionUpdate {
  category_id?: number | null;
  question?: string;
  answer?: string;
  difficulty?: "easy" | "medium" | "hard";
  tags?: string[];
  status?: "unanswered" | "answered";
  source?: string;
  notes?: string;
}

export interface QuestionFilters {
  category_id?: number;
  difficulty?: string;
  status?: string;
  search?: string;
}

function qaApiBase(): string {
  return localStorage.getItem("authUserType") === "admin"
    ? "/admin/interview-qa"
    : "/employee/interview-qa";
}

// Categories
export async function listCategories(): Promise<InterviewCategory[]> {
  const res = await api.get(`${qaApiBase()}/categories`);
  return res.data;
}

export async function createCategory(data: CategoryCreate): Promise<InterviewCategory> {
  const res = await api.post(`${qaApiBase()}/categories`, data);
  return res.data;
}

export async function updateCategory(id: number, data: CategoryUpdate): Promise<InterviewCategory> {
  const res = await api.patch(`${qaApiBase()}/categories/${id}`, data);
  return res.data;
}

export async function deleteCategory(id: number): Promise<void> {
  await api.delete(`${qaApiBase()}/categories/${id}`);
}

// Questions
export async function listQuestions(filters: QuestionFilters = {}): Promise<InterviewQuestion[]> {
  const params = new URLSearchParams();
  if (filters.category_id !== undefined) params.set("category_id", String(filters.category_id));
  if (filters.difficulty) params.set("difficulty", filters.difficulty);
  if (filters.status) params.set("status", filters.status);
  if (filters.search) params.set("search", filters.search);
  const res = await api.get(`${qaApiBase()}/questions?${params.toString()}`);
  return res.data;
}

export async function createQuestion(data: QuestionCreate): Promise<InterviewQuestion> {
  const res = await api.post(`${qaApiBase()}/questions`, data);
  return res.data;
}

export async function updateQuestion(id: number, data: QuestionUpdate): Promise<InterviewQuestion> {
  const res = await api.patch(`${qaApiBase()}/questions/${id}`, data);
  return res.data;
}

export async function deleteQuestion(id: number): Promise<void> {
  await api.delete(`${qaApiBase()}/questions/${id}`);
}
